import { type Enum } from '@webapp/infrastructure/types/Enum'

export const RoleTypes = {
  DEFAULT: 0,
  ROLE: 1,
  FILTER: 2,
  CUSTOM: 3,
} as const

export type RoleTypeEnum = Enum<typeof RoleTypes>
